import { render } from "./IconClose.vue?vue&type=template&id=4d54ff5c&scoped=true&ts=true"
import script from "./IconClose.vue?vue&type=script&lang=ts"
export * from "./IconClose.vue?vue&type=script&lang=ts"

import "./IconClose.vue?vue&type=style&index=0&id=4d54ff5c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d54ff5c"]])

export default __exports__